import React from "react";
import style from "./style.module.scss";
import Row from "./row";
import SkeletonRow from "../../../../../../../components/skeleton-loader/table/row";

const RetrievalTable = ({ data = [], loading }) => {
  const tableData = Array.isArray(data) ? data : [];
  return (
    <div className={style.batch_table_container}>
      <table className={style.batch_table}>
        <thead>
          <tr className={style.header_row}>
            {/* <th className={style.header_cell}></th> */}
            <th className={`${style.header_cell} ${style.padding_left}`}>
              Card
            </th>
            <th className={style.header_cell}>Card Type</th>
            <th className={style.header_cell}>POST Date</th>
            <th className={style.header_cell}>Batch Date</th>
            <th className={style.header_cell}>Reference no.</th>
            <th className={style.header_cell}>Amount</th>
            <th className={style.header_cell}>To Rebut</th>
            <th className={style.header_cell}>Respond</th>
            <th className={style.header_cell} style={{ width: "360px" }}>
              Reason
            </th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            Array.from({ length: 10 }).map((_, index) => (
              <SkeletonRow
                key={`batch-data-skeleton-row-${index}`}
                columnLength={9}
              />
            ))
          ) : tableData.length === 0 ? (
            <tr>
              <td colSpan="10" className={style.no_data}>
                No data to display
              </td>
            </tr>
          ) : (
            tableData.map((row, index) => <Row data={row} key={index} />)
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RetrievalTable;
